export default "__VITE_ASSET__C2pKz$yn__"